'use client';

import { authClient } from '@/lib/auth/auth-client';
import { useEffect, useRef } from 'react';

let oneTapInitialized = false;

export function GoogleOneTap() {
  const { data: session, isPending } = authClient.useSession();

  // Track if we've already checked the auth state initially.
  // We only want to trigger One Tap if the user is logged out on initial load.
  // If they start logged in, and later sign out, we DO NOT want to bombard them
  // with a One Tap prompt immediately after they explicitly chose to sign out.
  const hasCheckedInitialAuth = useRef(false);

  useEffect(() => {
    // Wait until the initial session check is complete
    if (isPending) return;

    // Only run this initialization block once per component lifecycle
    if (!hasCheckedInitialAuth.current) {
      hasCheckedInitialAuth.current = true;

      // Only attempt to initialize if no session and not already initialized globally
      if (!session && !oneTapInitialized) {
        oneTapInitialized = true;
        console.log('[GoogleOneTap] Initializing One Tap / FedCM flow via plugin...');

        // Create an abort controller to cleanly cancel the request if the component unmounts
        const controller = new AbortController();

        authClient
          .oneTap({
            fetchOptions: {
              signal: controller.signal,
            },
            callbackURL: window.location.href,
          })
          .catch((err) => {
            // Gracefully ignore AbortErrors which are expected when navigating away or remounting
            if (err.name === 'AbortError' || err.message?.includes('AbortError')) {
              console.log(
                '[GoogleOneTap] Flow aborted cleanly (user navigated away or component unmounted).'
              );
              return;
            }
            console.warn('[GoogleOneTap] One Tap flow failed:', err);
          });

        return () => {
          // Clean up the request when the component unmounts
          controller.abort();
        };
      }
    }
  }, [session, isPending]);

  return null;
}
